import { useCallback, useEffect, useState, useId } from 'react';
import MenuComponent, { MenuProps } from './Menu.component';

type CustomMenuProps = Omit<MenuProps, 'id' | 'isShowingMenu' | 'onToggleMenu'>;

const Menu = (props: CustomMenuProps): JSX.Element => {
  const [isShowingMenu, setIsShowingMenu] = useState(false);
  const randomId = useId().replace(/:/g, '');
  const formattedId = `dialog-id-${randomId}`;

  const onToggleMenu = useCallback((): void => {
    setIsShowingMenu((prev) => !prev);
  }, []);

  const onPageClick = useCallback((): void => {
    setIsShowingMenu(false);
  }, []);

  useEffect(() => {
    window.addEventListener('click', onPageClick);
    return () => {
      window.removeEventListener('click', onPageClick);
    };
  }, [onPageClick]);

  return (
    <MenuComponent
      {...props}
      onToggleMenu={onToggleMenu}
      id={formattedId}
      isShowingMenu={isShowingMenu}
    />
  );
};

export default Menu;
